import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  DatePicker,
  TimePicker,
  SelectDropdown,
  ErrorMessage,
  Checkbox,
} from '@gsa/afp-component-library';

const UpdateContractLineModalForm = ({ formData }) => {
  const [minDate, setMinDate] = useState(undefined);
  const [maxDate, setMaxDate] = useState(undefined);
  const getISODate = (dateStr) => {
    if (!dateStr) return undefined;
    const date = new Date(dateStr);
    // Check if date is valid
    if (Number.isNaN(date.getTime())) return undefined;
    return date.toISOString().substring(0, 10);
  };
  const fields = ['openDate', 'openTime', 'closeDate', 'closeTime', 'isDirect'];

  const { checked, errors, values, setValue, setCheck } = formData;

  const setCheckAll = (isChecked) => {
    fields.forEach((field) => {
      if (isChecked !== checked[field]) setCheck(field, isChecked);
    });
  };

  return (
    <div className="padding-3 bg-primary-lighter">
      <div className="grid-row margin-bottom-2 text-bold">
        Select fields to be updated
        <Button
          variant="unstyled"
          className="margin-left-2"
          label="Select all"
          onClick={() => setCheckAll(true)}
        />
        <Button
          variant="unstyled"
          className="margin-left-2"
          label="Unselect all"
          onClick={() => setCheckAll(false)}
        />
      </div>
      <div className="grid-row margin-bottom-1">
        <div className="grid-col-4 padding-bottom-1">
          <Checkbox
            id="open-date-checkbox"
            label="Open date"
            checked={checked.openDate}
            onChange={(e) => setCheck('openDate', e.target.checked)}
          />
        </div>
        <div className="grid-col-4">
          {checked.openDate && (
            <DatePicker
              id="open-date"
              name="open-date"
              defaultValue={values.openDate}
              errorMessage={errors.openDate}
              maxDate={maxDate}
              onChange={(v) => {
                setValue('openDate', v);
                setMinDate(getISODate(v));
              }}
            />
          )}
        </div>
      </div>
      <div className="grid-row margin-bottom-1">
        <div className="grid-col-4 padding-bottom-1">
          <Checkbox
            id="open-time-checkbox"
            label="Open time"
            checked={checked.openTime}
            onChange={(e) => setCheck('openTime', e.target.checked)}
          />
        </div>
        <div className="grid-col-4">
          {checked.openTime && (
            <div className="grid-row flex-align-baseline">
              <TimePicker
                id="open-time"
                name="open-time"
                defaultValue={values.openTime}
                errorMessage={errors.openTime}
                onChange={(v) => setValue('openTime', v)}
              />
              <div className="margin-left-2">ET</div>
            </div>
          )}
        </div>
      </div>
      <div className="grid-row margin-bottom-1">
        <div className="grid-col-4 padding-bottom-1">
          <Checkbox
            id="close-date-checkbox"
            label="Closeout date"
            checked={checked.closeDate}
            onChange={(e) => setCheck('closeDate', e.target.checked)}
          />
        </div>
        <div className="grid-col-4">
          {checked.closeDate && (
            <DatePicker
              id="close-date"
              name="close-date"
              defaultValue={values.closeDate}
              errorMessage={errors.closeDate}
              minDate={minDate}
              onChange={(v) => {
                setValue('closeDate', v);
                setMaxDate(getISODate(v));
              }}
            />
          )}
        </div>
      </div>
      <div className="grid-row margin-bottom-1">
        <div className="grid-col-4 padding-bottom-1">
          <Checkbox
            id="close-time-checkbox"
            label="Closeout time"
            checked={checked.closeTime}
            onChange={(e) => setCheck('closeTime', e.target.checked)}
          />
        </div>
        <div className="grid-col-4">
          {checked.closeTime && (
            <div className="grid-row flex-align-baseline">
              <TimePicker
                id="close-time"
                name="close-time"
                defaultValue={values.closeTime}
                errorMessage={errors.closeTime}
                onChange={(v) => setValue('closeTime', v)}
              />
              <div className="margin-left-2">ET</div>
            </div>
          )}
        </div>
      </div>
      <div className="grid-row minh-3 margin-bottom-1">
        <div className="grid-col-4 padding-bottom-1">
          <Checkbox
            id="is-direct-checkbox"
            label="Direct"
            checked={checked.isDirect}
            onChange={(e) => setCheck('isDirect', e.target.checked)}
          />
        </div>
        <div className="grid-col-3">
          {checked.isDirect && errors.isDirect && (
            <ErrorMessage>{errors.isDirect}</ErrorMessage>
          )}
          {checked.isDirect && (
            <SelectDropdown
              id="is-direct"
              name="is-direct"
              value={values.isDirect}
              options={[
                { value: '', label: '-' },
                { value: 'Yes', label: 'Yes' },
                { value: 'No', label: 'No' },
              ]}
              onChange={(e) => setValue('isDirect', e.target.value)}
            />
          )}
        </div>
      </div>
    </div>
  );
};

UpdateContractLineModalForm.propTypes = {
  formData: PropTypes.shape(Object).isRequired,
};

export default UpdateContractLineModalForm;
